import React from 'react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Paragraph,
  Checkbox,
  Flex,
  Button,
  rem,
} from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { T_CANCEL } from '@vimeo/live-core/translations';
import { CallablePlaceholder } from '@vimeo/live-core/types/general';

import { createInteractionDomName } from '../../../../libs/shared/utils/dom/identifying';
import { translations } from '../../../../translations';
import { IModalProps } from './useModalProps';

export function ChatHistoryModal({
  className = createInteractionDomName('chat-modal'),
  active,
  header,
  text,
  cancelAction,
  confirmAction,
  showAskAgainCheckBox = false,
  onCheck = CallablePlaceholder,
}: IBaseDomElementProps & IModalProps) {
  return (
    <Modal size={'sm'} isOpen={active} onClose={CallablePlaceholder}>
      <ModalOverlay />

      <ModalContent className={createInteractionDomName(className, 'content')}>
        <ModalHeader className={createInteractionDomName(className, 'header')}>
          {header}
        </ModalHeader>

        <ModalBody>
          <Paragraph
            className={createInteractionDomName(className, 'text')}
            size={'md'}
            display={'block'}
          >
            {text}
          </Paragraph>
        </ModalBody>

        <ModalFooter flexDirection={'column'}>
          {showAskAgainCheckBox ? (
            <Checkbox
              className={createInteractionDomName(className, 'checkbox')}
              width={'100%'}
              color={'text-primary'}
              autoFocus={false}
              onChange={onCheck}
            >
              {translations.dontAskMeAgainToDelete}
            </Checkbox>
          ) : null}

          <Flex gap={rem(16)} width={'100%'}>
            <Button
              className={createInteractionDomName(className, 'cancel-button')}
              variant={'secondary'}
              width={'100%'}
              onClick={cancelAction}
            >
              {T_CANCEL}
            </Button>

            <Button
              className={createInteractionDomName(className, 'confirm-button')}
              variant={'destructive'}
              width={'100%'}
              onClick={confirmAction}
            >
              {translations.confirm}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
